<template>
  <v-container style="max-width: 100%; padding: 0px; margin-top: -1.5em;">
    <v-flex>
      <div class="timeline-container">
        <div style="width: 100%; height: 100%;">
          <div class="night_sky">
            <div class="night">
              <div v-for="i in 30" :key="i" class="shooting_star"></div>
            </div>
            <h2 class="card-title glow">
              <span>{{ glowBannerString }}</span>
            </h2>
            <v-timeline class="text-timeline" :dense="isSmall">
              <v-timeline-item style="padding-bottom: 0px" :icon="cards[0].icon" color="rgba(0,0,0,.87)" small>
                <v-alert :value="true" class="home-content-card white">
                  <h2>{{ cards[0].title }}</h2>
                  <v-row dense style="text-align: left;">
                    <ol v-if="cards[0].numbered">
                      <li v-for="(cardContent, index) in cards[0].content" :key="index">
                        <span>
                          {{ cardContent }}
                        </span>
                      </li>
                    </ol>
                    <ul v-else>
                      <li v-for="(cardContent, index) in cards[0].content" :key="index">
                        <span>
                          {{ cardContent }}
                        </span>
                      </li>
                    </ul>
                  </v-row>
                </v-alert>
              </v-timeline-item>
              <v-timeline-item style="padding-bottom: 0px" :icon="cards[1].icon" color="rgba(0,0,0,.87)" small>
                <template>
                  <v-alert :value="true" class="home-content-card blue">
                    <h2>{{ cards[1].title }}</h2>
                    <v-row>
                      <ol v-if="cards[1].numbered">
                        <li v-for="(cardContent, index) in cards[1].content" :key="index">
                          <span>
                            {{ cardContent }}
                          </span>
                        </li>
                      </ol>
                      <ul v-else>
                        <li v-for="(cardContent, index) in cards[1].content" :key="index">
                          <span>
                            {{ cardContent }}
                          </span>
                        </li>
                      </ul>
                    </v-row>
                  </v-alert>
                </template>
                <div></div>
              </v-timeline-item>
              <v-timeline-item style="padding-bottom: 0px" :icon="cards[2].icon" color="rgba(0,0,0,.87)" small>
                <template>
                  <v-alert :value="true" class="home-content-card red">
                    <h2>{{ cards[2].title }}</h2>
                    <v-row>
                      <ol v-if="cards[2].numbered">
                        <li v-for="(cardContent, index) in cards[2].content" :key="index">
                          <span>
                            {{ cardContent }}
                          </span>
                        </li>
                      </ol>
                      <ul v-else>
                        <li v-for="(cardContent, index) in cards[2].content" :key="index">
                          <span>
                            {{ cardContent }}
                          </span>
                        </li>
                      </ul>
                    </v-row>
                  </v-alert>
                </template>
                <div></div>
              </v-timeline-item>
            </v-timeline>
          </div>
        </div>
      </div>
      <!-- <v-row>
        <v-col md="6" cols="12">
          <v-flex>
            <v-card id="home-icon-flipper-card" class="icon-flipper logo-container icon-bounce">
              <img id="home-icon-flipper" :src="currentIconSrc" />
            </v-card>
          </v-flex>
          <h2 class="gradient-text center">{{ currentIconCategory }}</h2>
          <v-row>
            <v-col class="center" cols="5">
              <span class="gradient-text">EASY!</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="6" class="center py-2 px-2" cols="12">
          <v-container v-if="cardVisisbility" @mouseenter="stopCardFlipEffect" @mouseleave="restartCardFlip"
            class="flip-card">
            <div :class="{ flipped: isFlipped }" class="flip-card-inner">
              <v-card class="flip-card-front flip-card">
                <v-row>
                  <v-col sm="5" cols="6">
                    <img style="width: 100%;" :src="card.src" />
                  </v-col>
                  <v-col sm="7" cols="6">
                    <h2>{{ card.title }}</h2>
                    <p v-if="card.content.length">{{ card.content[0] }}</p>
                    <ol v-if="card.numbered">
                      <li class="flipper-list-row"
                        v-for="(cardContent, index) in card.content.slice(1, card.content.length)" :key="index">
                        <span>
                          {{ cardContent }}
                        </span>
                      </li>
                    </ol>
                    <ul v-else>
                      <li class="flipper-list-row"
                        v-for="(cardContent, index) in card.content.slice(1, card.content.length)" :key="index">
                        <span>
                          {{ cardContent }}
                        </span>
                      </li>
                    </ul>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="flip-card-back flip-card">
                <v-row>
                  <v-col sm="5" cols="6">
                    <img style="width: 100%;" :src="card.src" />
                  </v-col>
                  <v-col md="7" cols="6">
                    <h2>{{ card.title }}</h2>
                    <p v-if="card.content.length">{{ card.content[0] }}</p>
                    <ol v-if="card.numbered">
                      <li class="flipper-list-row"
                        v-for="(cardContent, index) in card.content.slice(1, card.content.length)" :key="index">
                        <span>
                          {{ cardContent }}
                        </span>
                      </li>
                    </ol>
                    <ul v-else>
                      <li class="flipper-list-row"
                        v-for="(cardContent, index) in card.content.slice(1, card.content.length)" :key="index">
                        <span>
                          {{ cardContent }}
                        </span>
                      </li>
                    </ul>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </v-container>
        </v-col>
      </v-row> -->
      <v-row style="min-height: 400px;">
        <v-col class="pa-3 center" md="6" sm="8" cols="10">
          <v-slide-x-transition mode="out-in">
            <v-card transition="slide-x-transition" v-show="middleShow" class="home-media-card" :elevation="5"
              style="margin-top: .5em;">
              <img width="100%" :src="mapsIcon" />
            </v-card>
          </v-slide-x-transition>
        </v-col>
        <v-col md="6" sm="10" cols="12" class="center" :class="isSmall ? 'px-6' : 'px-12'" dense>
          <v-slide-x-reverse-transition mode="out-in">
            <v-card transition="slide-x-transition" v-show="middleShow" class="home-content-card red px-4">
              <h2 class="mx-0 my-2">Putting Your Business On The Map</h2>
              <p>
                Real Deal utilizes live data to provide our users with maximum visibility to your business and any
                promotions you may want to advertise.
                Our goal is to get our local business partners in front of as many users as possible to re-build Main
                Street
                American communities.
                We've built a streamlined process to get you off to the races and an intuitive analytics expierince to
                provide you with data-driven insights.
              </p>
            </v-card>
          </v-slide-x-reverse-transition>
        </v-col>
      </v-row>
      <v-row style="min-height: 300px;" :class="isSmall ? 'flex-column-reverse' : ''">
        <v-col md="6" sm="10" cols="12" class="center" :class="isSmall ? 'px-6' : 'px-12'" dense>
          <v-slide-x-transition mode="out-in">
            <v-card v-show="finalShow" class="home-content-card white px-4">
              <h2 class="mx-0 my-2">Analyzing What Works</h2>
              <p>
                Real Deal metrics make it quick and easy to know which promos drive traffic to your business and what ad
                areas give you the most traction.
                We set you up with a personalized dashboard and a plethora of ways for you to personalize your reporting
                experience.
              </p>
            </v-card>
          </v-slide-x-transition>
        </v-col>
        <v-col class="pa-3 center" md="6" sm="8" cols="10" dense>
          <v-slide-x-reverse-transition mode="out-in">
            <v-card v-show="finalShow" class="sparkline-container" :elevation="5" style="margin-top: .5em;">
              <v-row dense style="height: 50px; margin-left: auto !important;">
                <v-btn-toggle class="mr-6" style="margin-left: auto;" mandatory v-model="graphSetting"
                  :selected-class="graphSetting == 0 ? 'ad-icon' : graphSetting == 1 ? 'rev-icon' : 'contract-icon'">
                  <v-btn class="content-switch-btn ad-btn" :value="0">Reach</v-btn>
                  <v-btn class="content-switch-btn rev-btn" :value="1">Revenue</v-btn>
                  <v-btn class="content-switch-btn contract-btn" :value="2">Contracts</v-btn>
                </v-btn-toggle>
              </v-row>
              <v-row class="justify-end" style="width: 100%">
                <v-row v-if="graphSetting == 0" class="data-label">
                  <v-col cols="2">0 views</v-col>
                  <v-col cols="2">20,000 views</v-col>
                  <v-col cols="2">200,000 views</v-col>
                </v-row>
                <v-row v-else-if="graphSetting == 1" class="data-label">
                  <v-col cols="2">$0</v-col>
                  <v-col cols="2">$10,000</v-col>
                  <v-col cols="2">$50,000</v-col>
                </v-row>
                <v-row v-if="graphSetting == 2" class="data-label">
                  <v-col cols="2">0</v-col>
                  <v-col cols="2">15</v-col>
                  <v-col cols="2">60</v-col>
                </v-row>
                <v-col cols="12">
                  <v-sparkline v-if="graphSetting == 0" auto-draw type="trend" :smooth="7" :labels="lables"
                    :value="viewsSparkline" line-width="2" label-size="5.5" height="90" style="width: 100%;"
                    stroke-linecap="round"></v-sparkline>
                  <v-sparkline v-if="graphSetting == 1" auto-draw type="trend" :smooth="7" :labels="lables"
                    :value="revSparkline" line-width="2" label-size="5.5" height="90" style="width: 100%;"
                    stroke-linecap="round"></v-sparkline>
                  <v-sparkline v-if="graphSetting == 2" auto-draw type="trend" :smooth="7" :labels="lables"
                    :value="contractSparkline" line-width="2" label-size="5.5" height="90" style="width: 100%;"
                    stroke-linecap="round"></v-sparkline>
                </v-col>
              </v-row>
            </v-card>
          </v-slide-x-reverse-transition>
        </v-col>
      </v-row>
    </v-flex>
  </v-container>
</template>

<style lang="scss" scoped>
@import '../../styles/styles.scss';

.toggle-container {
  height: 50px;
  margin: auto 0.5em 0px;
}

.contract-btn {
  border-top-right-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}

.ad-btn {
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}

.data-label {
  justify-content: space-between;

  div:first-child {
    text-align: left;
  }

  div:nth-child(2) {
    text-align: center;
  }

  div:last-child {
    text-align: right;
  }
}

.v-timeline-item__inner-dot .v-icon {
  font-size: 12px !important;
}

.v-timeline:before {
  background: #f2462e !important;
  width: 3px !important;
  border-radius: 3px;
}
</style>

<script>
import mapsImg from '../../assets/Maps-Preview.png';
import moment from 'moment';

export default {
  name: 'home-page',
  data: () => ({
    glowBannerString: 'Welcome!',
    graphSetting: 0,
    currentIcon: 0,
    currentCard: 0,
    maxCardIndex: 0,
    cardFlipInterval: 0,
    middleShow: false,
    finalShow: false,
    isFlipped: false,
    animate: true,
    Icons: [
      {
        src: require('../../assets/Neon-Ferris.svg'),
        category: 'Fairs/Festivals',
      },
      {
        src: require('../../assets/Neon-Bowling.svg'),
        category: 'Competition',
      },
      {
        src: require('../../assets/Neon-Heavy-Bag.svg'),
        category: 'Fitness',
      },
      {
        src: require('../../assets/Neon-Diver.svg'),
        category: 'Experiences',
      },
      {
        src: require('../../assets/Neon-Tractor.svg'),
        category: 'Seasonal',
      },
    ],
    cards: [
      {
        title: 'Online Expansion',
        numbered: false,
        content: [
          'The Real Deal portal provides a presence for any partner business on mobile/desktop platforms.',
          'Simple business blogging hosted on your Real Deal site with integrations to post on social networks.'
        ],
        icon: 'fa-solid fa-earth-americas',
        src: require('../../assets/DN-Proximity.svg'),
      },
      {
        title: 'Marketing Tools',
        icon: 'fa-solid fa-wrench',
        numbered: true,
        content: [
          'Real Deal provides a site builder, search engine optimization, analytics, and much more.',
          'Targeted marketing campaigns via email/phone and deal analytics',
          'More updates/features added daily from customer feedback'
        ],
        src: require('../../assets/Business-Network.svg'),
      },
      {
        title: 'Purpose',
        numbered: false,
        content: [
          'America was built by small business and it is crucial to our country that we continue to shop small and fortify local business relationships.'
        ],
        icon: 'fa-solid fa-lightbulb',
        src: '',
      },
    ],
  }),
  computed: {
    bottomCardHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 400;
        case 'sm':
          return 400;
        case 'md':
          return 300;
        default:
          return 300;
      }
    },
    viewsSparkline() {
      return [0, 9, 5, 9, 5, 15, 10, 20, 12, 22, 25];
    },
    revSparkline() {
      return [0, 15, 7, 10, 15, 13, 12, 20, 23, 25, 30];
    },
    contractSparkline() {
      return [0, 5, 6, 7, 10, 2, 3, 2, 5, 8, 12];
    },
    lables() {
      const today = moment(),
        labels = [];

      for (let i = 0; i < 12; i++) {
        labels.push(today.add(i + 1, 'months').format('MMM YY'));
      }

      return labels;
    },
    isSmall() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return true;
        case 'sm':
          return true;
        default:
          return false;
      }
    },
    currentIconSrc: function () {
      return this.Icons[this.currentIcon].src;
    },
    currentIconCategory: function () {
      return this.Icons[this.currentIcon].category;
    },
    card: function () {
      return this.cards[this.currentCard];
    },
    mapsIcon() {
      return mapsImg;
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  created() {
    setTimeout(() => {
      this.glowBannerString = 'Why Partner With Real Deal?';
    }, 4000);

    setInterval(() => {
      if (this.currentIcon === this.Icons.length - 1) {
        this.currentIcon = 0;
      } else {
        this.currentIcon++;
      }
    }, 5000);

    this.cardFlipInterval = setInterval(() => {
      this.isFlipped = this.currentCard % 2 === 0;
      if (this.currentCard >= this.cards.length - 1) {
        this.currentCard = 0;
      } else {
        this.currentCard++;
      }
    }, 5000);
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      console.log(window.scrollY);
      if (window.scrollY > 525) {
        this.finalShow = true;
      } else if (window.scrollY > 160) {
        this.middleShow = true;
      }
    },
    restartCardFlip: function () {
      console.log('restartCardFlip');
      this.cardFlipInterval = setInterval(() => {
        this.isFlipped = this.currentCard % 2 === 0;
        if (this.currentCard >= this.cards.length - 1) {
          this.currentCard = 0;
        } else {
          this.currentCard++;
        }
      }, 5000);
    },
    stopCardFlipEffect: function () {
      console.log('stopCardFlip');
      clearInterval(this.cardFlipInterval);
    },
  },
};
</script>
